export const numberWithComma = target => target.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

// TODO check src/views/my/order/OrderHistoryDetail.vue:78
export const convertToOrderNumber = (number) => {
  if (number === null || number === undefined) return ''
  
  let digit = number
  let digitResult = 1

  while (digit > 9) {
    digitResult++
    digit /= 10
  }

  let result = ''

  for (let i = 0; i < 12 - digitResult; i++) result += '0'

  return result + number.toString()
}

export default {}
